/**
 * 單據／選料用 Material Unit 標籤：`code - name`。
 * @param {{ code?: string, name?: string }|null|undefined} unit
 * @returns {string}
 */
export function formatMaterialUnitLabel(unit) {
  const code = String(unit?.code ?? '').trim();
  const name = String(unit?.name ?? '').trim();
  if (code && name) {
    return `${code} - ${name}`;
  }
  return code || name || '';
}
